// import { Injectable, NgZone } from '@angular/core';
// import { io, Socket } from 'socket.io-client';
// import { environment } from '../../../environments/environment';
// import { Observable, Subject } from 'rxjs'; // 🔧 CHANGED — added Subject

// @Injectable({ providedIn: 'root' })
// export class SocketService {
//   private socket!: Socket;

//   // 🔧 FIX — kept for reference/back-compat but no longer used as the
//   // room name sent to the server. Backend rooms are joined via the
//   // connectAdminNotification / connectProviderNotification events
//   // below, and the actual room name is decided server-side.
//   private readonly ADMIN_ROOM = 'ADMIN_NOTIFICATION';
//   private readonly PROVIDER_ROOM = 'PROVIDER_NOTIFICATION';

//   // fires every time the socket (re)connects.
//   // Consumers can use this to resync state (re-fetch via REST)
//   // instead of relying solely on push events, which can be missed
//   // during brief reconnect windows / room-join races.
//   private connectedSubject = new Subject<void>();
//   connected$ = this.connectedSubject.asObservable();

//   constructor(private zone: NgZone) {}

//   connect(userId: string, role: 'ADMIN' | 'CUSTOMER' | 'PROVIDER') {
//     if (this.socket && this.socket.connected) return;

//     // if a previous (possibly broken/stale) socket exists, tear it
//     // down fully before creating a new one.
//     if (this.socket) {
//       console.log('♻️ Disconnecting stale socket before reconnecting');
//       this.socket.removeAllListeners();
//       this.socket.disconnect();
//     }

// // auth is a callback so it's re-evaluated on every connect/reconnect
//     // attempt, instead of freezing the token that existed when io()
//     // was first called.
//     //
//     // backend registers all these handlers on the
//     // '/GroceryNotifications' namespace (see GroceryNotifications.js:
//     // `SocketIO.of('/GroceryNotifications')`), not on the root
//     // namespace.
//     //
//     // 🔧 FIX — environment.SOCKET_ENDPOINT has a trailing slash
//     // ("https://.../devtunnels.ms/"), so naive concatenation produced
//     // a double slash ("...ms//GroceryNotifications"), which Socket.IO
//     // parses as an invalid namespace. Strip any trailing slash(es)
//     // before appending the namespace path.
//     const socketUrl = `${environment.SOCKET_ENDPOINT.replace(/\/+$/, '')}/GroceryNotifications`;
//     console.log('🔌 Connecting to socket URL:', socketUrl);

//     this.socket = io(socketUrl, {
//       transports: ['websocket'],
//       auth: (cb: (data: any) => void) => {
//         const token = localStorage.getItem('token');
//         cb({ 'x-authorization': token, userId, role });
//       },
//       reconnection: true
//     });

//     this.socket.on('connect', () => {
//       this.zone.run(() => {
//         console.log('🟢 Socket connected:', this.socket.id);

//         if (role === 'ADMIN') {
//           this.joinAdminNotificationRoom();
//         }

//         if (role === 'PROVIDER') {
//           this.joinProviderNotificationRoom();
//         }

//         // let consumers resync (e.g. re-fetch orders)
//         // every time we get/regain a connection.
//         this.connectedSubject.next();
//       });
//     });

//     this.socket.on('connect_error', (error) => {
//       this.zone.run(() => {
//         console.error('❌ Socket connection error:', error);
//       });
//     });

//     this.socket.on('disconnect', (reason) => {
//       this.zone.run(() => {
//         console.log('🔴 Socket disconnected:', reason);
//       });
//     });

//     this.socket.on('reconnect', () => {
//       this.zone.run(() => {
//         console.log('♻️ Socket reconnected');

//         if (role === 'ADMIN') {
//           this.joinAdminNotificationRoom();
//         }

//         if (role === 'PROVIDER') {
//           this.joinProviderNotificationRoom();
//         }

//         // same resync trigger on the Manager-level
//         // 'reconnect' event too (belt & suspenders — in some
//         // socket.io-client versions this fires separately from
//         // the socket-level 'connect' above).
//         this.connectedSubject.next();
//       });
//     });
//   }

//   disconnect() {
//     if (this.socket) {
//       console.log('🔌 Manually disconnecting socket');
//       this.socket.removeAllListeners();
//       this.socket.disconnect();
//     }
//   }

//   // 🔧 FIX — backend has no 'joinRoom' listener at all. The actual
//   // handler is 'connectAdminNotification', it takes no meaningful
//   // payload (server derives userId/role from socket.authInfo, set by
//   // the `authorize` middleware from the auth token), and it acks back
//   // { status, message, data: { room, userId } } — not a bare object,
//   // so we check res.status rather than assuming success.
//   private joinAdminNotificationRoom() {
//     this.socket.emit(
//       'connectAdminNotification',
//       {},
//       (res: any) => {
//         this.zone.run(() => {
//           if (!res?.status) {
//             console.error('❌ Failed to join ADMIN_NOTIFICATION room:', res);
//           } else {
//             console.log('🧩 Joined ADMIN_NOTIFICATION room:', res);
//           }
//         });
//       }
//     );
//   }

//   // 🔧 FIX — same issue: backend listens for 'connectProviderNotification',
//   // not 'joinRoom'.
//   private joinProviderNotificationRoom() {
//     this.socket.emit(
//       'connectProviderNotification',
//       {},
//       (res: any) => {
//         this.zone.run(() => {
//           if (!res?.status) {
//             console.error('❌ Failed to join PROVIDER_NOTIFICATION room:', res);
//           } else {
//             console.log('🧩 Joined PROVIDER_NOTIFICATION room:', res);
//           }
//         });
//       }
//     );
//   }

//   onOrderNotification(): Observable<any> {
//     return new Observable(observer => {

//       if (!this.socket) {
//         console.warn('⚠️ Socket is not initialized');
//         return;
//       }

//       console.log(
//         '👂 Attaching NEW_ORDER listener on socket:',
//         this.socket.id,
//         'connected:',
//         this.socket.connected
//       );

//       // 🔧 FIX — backend emits 'NEW_ORDER' via emitToAdmins('NEW_ORDER', {...}),
//       // never 'orderNotification'. Also unwrap the { data: {...} } envelope
//       // that emitToAdmins wraps every payload in.
//       const handler = (payload: any) => {
//         console.log('🔥 RAW NEW_ORDER event received:', payload);

//         this.zone.run(() => {
//           console.log('✅ NEW_ORDER handled inside NgZone');
//           observer.next(payload?.data ?? payload);
//         });
//       };

//       this.socket.on('NEW_ORDER', handler);

//       this.socket.onAny((eventName: string, ...args: any[]) => {
//         console.log('📡 [onAny] socket event received:', eventName, args);
//       });

//       return () => {
//         console.log('🧹 Removing NEW_ORDER listener');
//         this.socket.off('NEW_ORDER', handler);
//         this.socket.offAny();
//       };
//     });
//   }

//   // ⚠️ NOTE — the shared GroceryNotifications.js only shows the generic
//   // helper `emitToProvider(providerId, event, data)`; the actual event
//   // *name* used for provider pushes is decided wherever emitToProvider()
//   // is called elsewhere in your backend (not in the file you pasted).
//   // Confirm that name and swap it in below — 'providerNotification' is
//   // left as-is because it wasn't shown to be wrong, but it wasn't
//   // confirmed right either.
//   onProviderNotification(): Observable<any> {
//     return new Observable(observer => {

//       if (!this.socket) {
//         console.warn('⚠️ Socket is not initialized');
//         return;
//       }

//       const handler = (payload: any) => {
//         this.zone.run(() => {
//           observer.next(payload?.data ?? payload);
//         });
//       };

//       this.socket.on('providerNotification', handler);

//       return () => {
//         this.socket.off('providerNotification', handler);
//       };
//     });
//   }
// }




import { Injectable, NgZone } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../../environments/environment';
import { Observable, Subject } from 'rxjs'; // 🔧 CHANGED — added Subject

@Injectable({ providedIn: 'root' })
export class SocketService {
  private socket!: Socket;

  // 🔧 FIX — kept for reference/back-compat but no longer used as the
  // room name sent to the server. Backend rooms are joined via the
  // connectAdminNotification / connectProviderNotification events
  // below, and the actual room name is decided server-side.
  private readonly ADMIN_ROOM = 'ADMIN_NOTIFICATION';
  private readonly PROVIDER_ROOM = 'PROVIDER_NOTIFICATION';

  // fires every time the socket (re)connects.
  // Consumers can use this to resync state (re-fetch via REST)
  // instead of relying solely on push events, which can be missed
  // during brief reconnect windows / room-join races.
  private connectedSubject = new Subject<void>();
  connected$ = this.connectedSubject.asObservable();

  constructor(private zone: NgZone) {}

  connect(userId: string, role: 'ADMIN' | 'CUSTOMER' | 'PROVIDER') {
    if (this.socket && this.socket.connected) return;

    // if a previous (possibly broken/stale) socket exists, tear it
    // down fully before creating a new one.
    if (this.socket) {
      console.log('♻️ Disconnecting stale socket before reconnecting');
      this.socket.removeAllListeners();
      this.socket.disconnect();
    }

    // auth is a callback so it's re-evaluated on every connect/reconnect
    // attempt, instead of freezing the token that existed when io()
    // was first called.
    //
    // 🔧 FIX — backend registers all these handlers on the
    // '/GroceryNotifications' namespace (see GroceryNotifications.js:
    // `SocketIO.of('/GroceryNotifications')`), not on the root
    // namespace. Connecting without this path means `authorize`
    // middleware and every 'connect*Notification' handler simply
    // don't exist on the socket you're talking to.
const socketUrl = `${environment.SOCKET_ENDPOINT.replace(/\/+$/, '')}/GroceryNotifications`;

console.log('🔌 Connecting to socket URL:', socketUrl);

this.socket = io(socketUrl, {
  transports: ['websocket'],
  auth: (cb: (data: any) => void) => {
    const token = localStorage.getItem('token');

    cb({
      'x-authorization': token,
      userId,
      role
    });
  },
  reconnection: true
});

    this.socket.on('connect', () => {
      this.zone.run(() => {
        console.log('🟢 Socket connected:', this.socket.id);

        if (role === 'ADMIN') {
          this.joinAdminNotificationRoom();
        }

        if (role === 'PROVIDER') {
          this.joinProviderNotificationRoom();
        }

        // let consumers resync (e.g. re-fetch orders)
        // every time we get/regain a connection.
        this.connectedSubject.next();
      });
    });

    this.socket.on('connect_error', (error) => {
      this.zone.run(() => {
        console.error('❌ Socket connection error:', error);
      });
    });

    this.socket.on('disconnect', (reason) => {
      this.zone.run(() => {
        console.log('🔴 Socket disconnected:', reason);
      });
    });

    this.socket.on('reconnect', () => {
      this.zone.run(() => {
        console.log('♻️ Socket reconnected');

        if (role === 'ADMIN') {
          this.joinAdminNotificationRoom();
        }

        if (role === 'PROVIDER') {
          this.joinProviderNotificationRoom();
        }

        // same resync trigger on the Manager-level
        // 'reconnect' event too (belt & suspenders — in some
        // socket.io-client versions this fires separately from
        // the socket-level 'connect' above).
        this.connectedSubject.next();
      });
    });
  }

  disconnect() {
    if (this.socket) {
      console.log('🔌 Manually disconnecting socket');
      this.socket.removeAllListeners();
      this.socket.disconnect();
    }
  }

  // 🔧 FIX — backend has no 'joinRoom' listener at all. The actual
  // handler is 'connectAdminNotification', it takes no meaningful
  // payload (server derives userId/role from socket.authInfo, set by
  // the `authorize` middleware from the auth token), and it acks back
  // { status, message, data: { room, userId } } — not a bare object,
  // so we check res.status rather than assuming success.
  private joinAdminNotificationRoom() {
    this.socket.emit(
      'connectAdminNotification',
      {},
      (res: any) => {
        this.zone.run(() => {
          if (!res?.status) {
            console.error('❌ Failed to join ADMIN_NOTIFICATION room:', res);
          } else {
            console.log('🧩 Joined ADMIN_NOTIFICATION room:', res);
          }
        });
      }
    );
  }

  // 🔧 FIX — same issue: backend listens for 'connectProviderNotification',
  // not 'joinRoom'.
  private joinProviderNotificationRoom() {
    this.socket.emit(
      'connectProviderNotification',
      {},
      (res: any) => {
        this.zone.run(() => {
          if (!res?.status) {
            console.error('❌ Failed to join PROVIDER_NOTIFICATION room:', res);
          } else {
            console.log('🧩 Joined PROVIDER_NOTIFICATION room:', res);
          }
        });
      }
    );
  }

  onOrderNotification(): Observable<any> {
    return new Observable(observer => {

      if (!this.socket) {
        console.warn('⚠️ Socket is not initialized');
        return;
      }

      console.log(
        '👂 Attaching NEW_ORDER listener on socket:',
        this.socket.id,
        'connected:',
        this.socket.connected
      );

      // 🔧 FIX — backend emits 'NEW_ORDER' via emitToAdmins('NEW_ORDER', {...}),
      // never 'orderNotification'. Also unwrap the { data: {...} } envelope
      // that emitToAdmins wraps every payload in.
      const handler = (payload: any) => {
        console.log('🔥 RAW NEW_ORDER event received:', payload);

        this.zone.run(() => {
          console.log('✅ NEW_ORDER handled inside NgZone');
          observer.next(payload?.data ?? payload);
        });
      };

      this.socket.on('NEW_ORDER', handler);

      this.socket.onAny((eventName: string, ...args: any[]) => {
        console.log('📡 [onAny] socket event received:', eventName, args);
      });

      return () => {
        console.log('🧹 Removing NEW_ORDER listener');
        this.socket.off('NEW_ORDER', handler);
        this.socket.offAny();
      };
    });
  }

  // ⚠️ NOTE — the shared GroceryNotifications.js only shows the generic
  // helper `emitToProvider(providerId, event, data)`; the actual event
  // *name* used for provider pushes is decided wherever emitToProvider()
  // is called elsewhere in your backend (not shown yet). CONFIRM that
  // name and swap the string below — 'NEW_ORDER' is a
  // placeholder guess, patterned after the admin side's 'NEW_ORDER'.
  // Use the onAny() log (like the admin listener has) to see the real
  // event name arrive, then correct this string.
  private readonly PROVIDER_EVENT_NAME = 'NEW_ORDER'; // ⚠️ CONFIRM against backend

  onProviderNotification(): Observable<any> {
    return new Observable(observer => {

      if (!this.socket) {
        console.warn('⚠️ Socket is not initialized');
        return;
      }

      console.log(
        '👂 Attaching',
        this.PROVIDER_EVENT_NAME,
        'listener on socket:',
        this.socket.id,
        'connected:',
        this.socket.connected
      );

      const handler = (payload: any) => {
        console.log(`🔥 RAW ${this.PROVIDER_EVENT_NAME} event received:`, payload);

        this.zone.run(() => {
          observer.next(payload?.data ?? payload);
        });
      };

      this.socket.on(this.PROVIDER_EVENT_NAME, handler);

      // 🔍 DEBUG — logs every event the provider socket receives,
      // regardless of name. Use this to spot the real event name if
      // PROVIDER_EVENT_NAME above turns out to be wrong.
      this.socket.onAny((eventName: string, ...args: any[]) => {
        console.log('📡 [PROVIDER onAny] socket event received:', eventName, args);
      });

      return () => {
        console.log('🧹 Removing', this.PROVIDER_EVENT_NAME, 'listener');
        this.socket.off(this.PROVIDER_EVENT_NAME, handler);
        this.socket.offAny();
      };
    });
  }
}